import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FileCategory, FileTypes } from '../../shared/models/file-type';
import { Thumbnailable } from '../../shared/components/file-upload/thumb-nail-base.component';
import { DrLocalStorageService } from '@app/core/services/local-storage/dr-local-storage.service';
import { BaseService } from '@app/core/services/base/base.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PhotoEditorDialogComponent } from '@app/shared/dialogs/photo-editor-dialog/photo-editor-dialog.component';
import { DrFileMeta } from '@app/shared/models/dr-file';


@Injectable({
    providedIn: 'root'
})
export class FileUtilityService extends BaseService {

    constructor(protected localStorageService: DrLocalStorageService,
                private dialog: MatDialog) {
        super();
    }

    public fileAsBinaryString(file: File): Observable<string> {
        return new Observable((observer) => {
            const {next, error} = observer;

            const reader = new FileReader();

            reader.onload = function() {
                const binaryString = this.result;
                observer.next(binaryString as string);
                observer.complete();
            };

            reader.readAsArrayBuffer(file);

            return {unsubscribe() { }};
        });
    }

    public dataURLtoBlob(dataUrl: string) {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new Blob([u8arr], {type: mime});
    }

    public dataURLAsBinaryString(dataUrl: string, filename: string): Observable<string> {
        const blob: any = this.dataURLtoBlob(dataUrl);
        
        blob.name = filename;
        blob.lastModified = new Date();

        return this.fileAsBinaryString(<File>blob);
    }

    public addToken(): string {
        const user = this.localStorageService.get(this.localStorageService.STORAGE_KEY_USER);
        const token = user ? user.accessToken : null;
        return `${ token ? `?access-token=${ token }` : `` }`;
    }

    public viewFileInNewTab(fileMeta: Thumbnailable): void {
        const download = fileMeta.fileType.category !== FileCategory.PHOTO && fileMeta.fileType !== FileTypes.PDF && fileMeta.fileType !== FileTypes.XSL && fileMeta.fileType !== FileTypes.XSLT;
        this.windowOpen(fileMeta, download);
    }

    public downloadFile(fileMeta: Thumbnailable): void {
        this.windowOpen(fileMeta, true);
    }

    public downloadBlob(blob: Blob, type: string, fileName: string): void {
        blob = blob.slice(0, blob.size, type);
        const url = (window.URL || (<any>window).webkitURL).createObjectURL(blob);
        const element = document.createElement('a');
        element.href = url;
        element.download = fileName;
        document.body.appendChild(element);
        element.click();
    }

    private windowOpen(fileMeta: Thumbnailable, download: boolean): void {
        const target = download ? '_self' : '_blank';
        let url = `${fileMeta.thumbnailLink}${this.addToken()}`;
        url += download ? '&download=true' : '';

        if (download) {
            window.location.href = url;
        } else {
            const winHandle = window.open( 'about:blank', target);
            winHandle.location.href = url;
        }
    }

    public showPhotoEditor(fileMeta: DrFileMeta): Observable<string> {
        return new Observable((observer) => {
            const dialogRef = this.dialog.open(PhotoEditorDialogComponent, {
                hasBackdrop: true,
                panelClass: 'full-screen-modal',

                data: {
                    title: fileMeta.filename,
                    file: fileMeta,
                }
            });
    
            dialogRef.afterClosed().subscribe(dataUrl => {
                observer.next(dataUrl);
                observer.complete();
            });

            return {
                unsubscribe() {
                }
            };
        });
    }
}

